import { getObjectKeysAsObject } from "@checkout/helpers";
import { trackViewReview } from "@checkout/tracking/review";

export const services = {
  trackViewReview,
};

export const ServiceTypes = getObjectKeysAsObject(services);
